import * as React from "react";
import { DiscountInfoBox, SoldOutMask } from "./styles";
export class DiscountInfoCard extends React.PureComponent {
    render() {
        const { className = {}, discount } = this.props;
        if (discount === "0%") {
            return null;
        }
        return (React.createElement(DiscountInfoBox, { className: `${className}` },
            discount,
            React.createElement("br", null),
            "OFF"));
    }
}
export const TagWidthSoldOut = () => {
    return React.createElement(SoldOutMask, null);
};
